import { render } from "./SetQualityDialog.vue?vue&type=template&id=ba5059e6"
import script from "./SetQualityDialog.vue?vue&type=script&lang=js"
export * from "./SetQualityDialog.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__